module.exports = __webpack_public_path__ + "img/Paper-Plane.851fc02b.png";